import { useEffect, useState } from 'react';
import {useLocation} from "react-router-dom";
import {urls} from "../business/routes/urls";

export const usePageTitle = () => {

    const location = useLocation();

    const pageTitle = location.pathname === urls.tasksList
        ? 'Account Manager Tasks'
        : location.pathname === urls.statistics
            ? 'Proposal Activity Overview'
            : location.pathname === urls.confirmationCalls
                ? 'Confirmation Calls'
                : location.pathname === urls.tasksGraph
                    ? 'Account Manager Tasks Graph'
                    : '';

    return {pageTitle}
}